export const DEMO_HIDE_TAGS = [
    'JD-a3da8c8a',
    'JD-1c2fa23a',
    'JD-63da9138',
    'JD-08ca2bc4',
    'JD-93608786',
    'JD-34a901e7',
    'JD-fab40887'
] as const;

export const DEMO_HIDE_ENV_FLAG = 'VITE_HIDE_DEMO_RECORDS';
